import React, { FC } from 'react';
import { Flex, Heading } from '@edreamsodigeo/prisma-design-system';
import { AlternativeItineraryDoubleCardLayerTitleProps } from './types';

const AlternativeItineraryDoubleCardLayerTitle: FC<
  AlternativeItineraryDoubleCardLayerTitleProps
> = ({ children, sx }) => {
  return (
    <Flex
      flexDirection="column"
      sx={{ ...sx }}
      data-testid="alternative-itinerary-double-card-layer-title"
    >
      <Heading type="3" weight="medium" color="neutral.90">
        {children}
      </Heading>
    </Flex>
  );
};

export default AlternativeItineraryDoubleCardLayerTitle;
